import { ActionType, createAction } from 'typesafe-actions';
import { SchemaFulfilledPayload } from './types';

export const fetchSchema = createAction(
  'FETCH_SCHEMA',
  undefined,
  (schemaUrl: string) => ({
    schemaUrl,
  })
)<undefined, { schemaUrl: string }>();

export const fetchSchemaFulfilled = createAction(
  'FETCH_SCHEMA_FULFILLED',
  (payload: SchemaFulfilledPayload) => payload
)<SchemaFulfilledPayload>();

export type SchemaActions = ActionType<
  typeof fetchSchema | typeof fetchSchemaFulfilled
>;
